import React from "react";
import { ItemsStore } from "../store";
import { DashboardArea, GridFrame } from "../styles";
import ItemSideBar from "./ItemSideBar";
import { AuthService, Loader } from "@mindmemobile/mm-shared-global";

type IProps = {
  node: React.ReactNode;
  itemStore: ItemsStore;
  showMerchantAccountNotificationBar?: boolean;
  onlyShowNotificationBox?: boolean;
  showLoader?: boolean;
  className?: string;
};

const ItemContentArea: React.FC<IProps> = ({
  node,
  itemStore,
  showMerchantAccountNotificationBar = false,
  onlyShowNotificationBox = false,
  showLoader = false,
  className,
}) => {
  const showHeaderBar = !onlyShowNotificationBox;
  const height =
    (!showHeaderBar && showMerchantAccountNotificationBar
      ? "calc(100% - 80px)"
      : showHeaderBar && !showMerchantAccountNotificationBar
        ? "calc(100% - 130px)"
        : showHeaderBar && showMerchantAccountNotificationBar
          ? "calc(100% - 201px)"
          : !showHeaderBar && !showMerchantAccountNotificationBar
            ? "calc(100% - 0px)"
            : "") || "";
  return (
    <DashboardArea
      className={className}
      height={height}
      // notification - calc(100% - 80px)   -- tbody height
      // header without notification - 100% - 100px
      // header with noptification - 100% - 180px
      //no header no notification - 100% - 30px  -- tbody height
    >
      {!AuthService.hideLeftMenu && (
        <div style={{ flexShrink: 0, display: "flex" }}>
          {" "}
          <ItemSideBar itemStore={itemStore} />{" "}
        </div>
      )}

      {showLoader ? (
        <GridFrame>{new Loader(true).loaderComponent}</GridFrame>
      ) : (
        <GridFrame> {node}</GridFrame>
      )}
    </DashboardArea>
  );
};

export default ItemContentArea;
